import React, {useState} from 'react';
import {useSelector} from 'react-redux';

import {orderBy} from 'lodash';
import moment from 'moment';

import {labels} from '../../../../../../util/utils';
import {exportMessageLogs, timeFormat, MessageSend} from '../../../../../../util/uiconstants';

import ExportToExcel from '../../../../../Common/ExportToExcel/ExportToExcel';

import StyledExportMessageLog from './StyledExportMessageLog';

const ExportMessageLog = () => {
	const data = useSelector(({messageLog}) => messageLog.displayedMessages);
	const userDateFormat = useSelector((store) => store.userPreferences.dateFormat);

	const [isDisabled, setIsDisabled] = useState(false);

	const getExportDetails = () => {
		return {
			title: [labels.messageLogFileExported],
			columns: getColumnsToExport(),
			data: getDataToExport(),
			worksheetName: labels.messageLogFileExported
		};
	};

	const getColumnsToExport = () => {
		let columns = [];

		columns.push({header: labels.typeColumnToExportToExcel, key: exportMessageLogs.type});
		columns.push({header: labels.sentByColumnToExportToExcel, key: exportMessageLogs.sentBy});
		columns.push({header: labels.fromColumnToExportToExcel, key: exportMessageLogs.from});
		columns.push({header: labels.dateColumnToExportToExcel, key: exportMessageLogs.date});
		columns.push({header: labels.timeColumnToExportToExcel, key: exportMessageLogs.time});
		columns.push({header: labels.subjectColumnToExportToExcel, key: exportMessageLogs.subject});
		columns.push({header: labels.contactsColumnToExportToExcel, key: exportMessageLogs.contacts});

		return columns;
	};

	const getDataToExport = () => {
		let dataToExport = [];

		data?.forEach((message) => {
			dataToExport.push({
				type: getTypeToExport(message),
				sentBy: message?.sentBy,
				from: message?.from?.entityName,
				date: getDateToExport(message),
				time: getHourToExport(message),
				subject: message?.subject,
				contacts: getContactsToExport(message)
			});
		});

		return dataToExport;
	};

	const getTypeToExport = (message) => {
		if (message?.messageType === MessageSend.Email) {
			return labels.emailExportToExcel;
		}
		if (message?.messageType === MessageSend.Notification) {
			return labels.notificationExportToExcel;
		}
	};

	const getContactsToExport = (message) => {
		if (message?.contacts?.length > 0) {
			return orderBy(message?.contacts, (contact) => contact.firstName)
				.map((contact) => `${contact.firstName} ${contact.lastName}`)
				.join('; ');
		}

		return '';
	};

	const getDateToExport = (message) => {
		const date = moment.utc(message?.createdDateTime).local();
		return date.format(userDateFormat);
	};

	const getHourToExport = (message) => {
		const date = moment.utc(message?.createdDateTime).local();
		return date.format(timeFormat);
	};

	return (
		<StyledExportMessageLog>
			<ExportToExcel
				setIsDisabled={setIsDisabled}
				buttonTitle={labels.exportToExcel}
				buttonLabel={labels.exportToExcel}
				getDataToExport={getExportDetails}
			/>
		</StyledExportMessageLog>
	);
};

export default ExportMessageLog;
